import { createStandardAction } from 'typesafe-actions';
import { LoginCountFeedActions } from './LoginCountFeedActions';

export const RECEIVED_LOGIN_COUNT = `@loginCount/received`;
const receiveLoginCount = createStandardAction(RECEIVED_LOGIN_COUNT)<{ loginCount: number }>();

export const LoginCountActions = {
  ...LoginCountFeedActions,
  receivedLoginCount: receiveLoginCount,
};
